import { onload } from '@alife/bc-shop-base';
import preload from '@alife/icbu-bc-preload';
import safeLog from '@alife/bc-safe-log';
import queryString from 'query-string';
import initWpo from './src/wpo';
import initGoldlog from './src/goldlog';
// import initI18n from './src/i18n';
import scrollDot from './src/scroll-dot';
import initPerf from './src/perf';
import initFlasher from './src/flasher';
import SimpleDialog from './src/dialog';
// import checkSrcErr from './src/src-err';
import './index.scss';

export default function initCommonData(globalData) {
  const { product = {}, global = {}, seller = {} } = globalData;
  const { productId, productIsMarketGoods } = product;
  const { companyId } = seller;
  const { language = '' } = global;

  initWpo();
  initGoldlog();
  // initI18n();
  scrollDot();
  initPerf();
  initFlasher({ companyId });
  // checkSrcErr();

  // 请求新品数据，全局共享，供氛围使用
  window._FETCH_PROMOTION_NEW_PRODUCTS_ = function _FETCH_PROMOTION_NEW_PRODUCTS_() {
    return new Promise((res, rej) => {
      fetch(
        `/event/app/mainAction/promotion.htm?detailId=${productId}&language=${language}`,
      )
        .then(resp => resp.json())
        .then((json = {}) => {
          const { productNewSellPoints = '' } = json;
          res({
            productNewSellPoints,
          });
        })
        .catch(err => rej(err));
    });
  };

  window.SimpleDialog = SimpleDialog;

  // 加载异步模块
  onload(() => {
    // 预加载下单页js
    if (productIsMarketGoods) {
      preload({
        referer: 'product-details',
      });
    }

    /* 将外部的用户ID就和国际站的用户ID打通，打点携带取代id和用户id
     *
     * 需求: https://aone.alibaba-inc.com/req/25146592
     *
     * detail例子：https://www.alibaba.com/product-detail/Persons-Perfect-for-Relaxation-gravity-15lb_62026390363.html?src=amtool&tId=882014&userId=1
     */
    try {
      const parsed = queryString.parse(window.location.search);
      const { tId, userId } = parsed;
      if (tId && userId) {
        safeLog(
          '/sc.flow.tpBuyers',
          'OTHER',
          `sceneId=${tId}&userId=${userId}`,
          'GET',
        );
      }
      // eslint-disable-next-line no-empty
    } catch (error) {}
  });
}
